export const allowedGoogleMapsResultsTypes = [
  "locality",
  "route",
  "premise",
  "street_address",
  "address",
  "establishment",
  "point_of_interest",
  "subpremise",
];
